export default __webpack_public_path__ + "static/media/lysningen-property-12.5b772255.jpg";